import { useMemo } from 'react';
import { GET_PURCHASE_ORDERS_KEY } from '@/keys';

export function usePurchaseOrders() {
  const queryKey = useMemo(() => [...GET_PURCHASE_ORDERS_KEY] as const, []);

  return {
    queryKey,
  };
}
